import React from 'react';

import Button from '../Button/Button';
import './buttonShaded.scss';

/**
 * Usage:
 * <ButtonShaded className="ikt-ws_make-own-cabinet">
 *     MAKE YOUR OWN CABINET
 * </ButtonShaded>
 */

const ButtonShaded = props => {
  return (
    <Button
      {...props}
      className={`shaded${props.className ? ` ${props.className}` : ``}`}
    >
      {props.children}
    </Button>
  );
};

export default ButtonShaded;
